import { Controller } from "stimulus";

export default class extends Controller {
  static values = { url: String };

  onOptionChange(event) {
    window.location = this.urlValue.replace('id', event.target.value);
  }
}
